'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = exports.animateRemoveItemFromCart = undefined;

var _AddToCart = require('scripts/components/AddToCart');

var _CartCodes = require('scripts/components/CartCodes');

var _Helpers = require('scripts/components/Helpers');

var _Cart = require('scripts/modules/Cart');

// Components
var CART_MONEY_FORMAT = window.bva.moneyFormatOverride || '${{amount_no_decimals}}';
// Modules


var dom = {
  cartContainer: '[cart-container]',
  lineItem: '[line-item]',
  itemRemove: '[line-item-remove]',
  packRemove: '[line-item-pack-remove]',
  itemQtyAdjust: '[line-item-qty-adjust]',
  packQtyAdjust: '[pack-qty-adjust]',
  itemQty: '[line-item-qty]',
  subscriptionCheckbox: '[line-item-subscription-checkbox]',
  subscriptionIntervalInput: '[line-item-subscription-interval]',
  subscriptionIntervalSelect: '[line-item-subscription-interval-select]',
  noForm: 'noform',
  noteToggle: '[line-item-note-toggle]',
  note: '[line-item-note]'
};

var cbError = function cbError(state) {
  console.error(state);
  $(dom.cartContainer).removeClass('is-loading');
};

// animates removing an item/pack from the cart
var animateRemoveItemFromCart = exports.animateRemoveItemFromCart = function animateRemoveItemFromCart($lineItem) {
  var disableUIUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  $lineItem.addClass('line-item--removed');
  if (!disableUIUpdate) {
    setTimeout(function () {
      (0, _Cart.updateCartUI)();
    }, 600);
  }
};

var removeLineItemFromCart = function removeLineItemFromCart(event) {
  var $this = $(event.currentTarget);
  var $lineItem = $this.closest(dom.lineItem);
  var isPack = $lineItem.hasClass('is-pack');
  var isFreeGift = $this.attr('is-free-gift') || false;

  var removedCallBack = function removedCallBack() {
    animateRemoveItemFromCart($lineItem);
    if (window.bva.cart.item_count == 0) {
      (0, _Cart.cartContentFadeOut)();
      (0, _CartCodes.resetDiscountUI)();
    }
  };

  if (isFreeGift) {
    $this.trigger('blur');
    removedCallBack();
    $('[cart-code-container]').hide();
    setTimeout(function () {
      $('[cart-code-container]').show();
      (0, _CartCodes.resetDiscount)();
    }, 250);
    return false;
  } else if (isPack) {
    var packId = parseInt($lineItem.attr('data-pack-id'));
    return (0, _AddToCart.cartRemovePack)(packId).then(removedCallBack).catch(cbError);
  } else {
    var itemKey = $lineItem.attr('data-item-key');
    return (0, _AddToCart.cartRemove)(itemKey).then(removedCallBack).catch(cbError);
  }
};

var debounceQtyUpdate = (0, _Helpers.debounce)(function (event) {
  var $this = $(event.currentTarget);
  var $lineItem = $this.closest(dom.lineItem);
  var isPack = $lineItem.hasClass('is-pack');
  var qty = $this.val() >= 0 ? $this.val() : 0;

  // if we are removing the item, just hook into the remove item function
  if (qty === 0 || qty === '0') {
    return $lineItem.find(dom.itemRemove).click();
  }
  $lineItem.find('[line-item-qty]').val(qty);

  if (isPack) {
    var packId = $lineItem.attr('data-pack-id') || false;
    (0, _AddToCart.cartUpdatePack)(packId, qty).catch(cbError);
  } else {
    var itemKey = $lineItem.attr('data-item-key');
    (0, _AddToCart.cartChange)(itemKey, qty).catch(cbError);
  }
}, 500);

// const debounceSubscriptionToggle = debounce((event) => {
var subscriptionToggle = function subscriptionToggle(event) {
  if (event.type === 'keypress' && event.keyCode !== 13) return;else if (event.type === 'keypress' && event.keyCode === 13) event.currentTarget.checked = !event.currentTarget.checked;
  var $this = $(event.currentTarget);
  var $lineItem = $this.closest(dom.lineItem);
  var baseVariantId = $this.attr('data-base-variant-id');
  var subscriptionVariantId = $this.attr('data-variant-id');
  var itemKey = $lineItem.attr('data-item-key');
  var lineNumber = parseInt($this.attr('line-number'));
  var qty = $lineItem.find('[line-item-qty]').val();
  var lineIndex = lineNumber - 1;
  var item = window.bva.cart.items[lineIndex];
  var props = Object.assign({}, item.properties);
  var isChecked = $this.is(':checked');
  $(dom.cartContainer).addClass('is-loading');

  if (isChecked) {
    /* Replace base variant with subscription variant plus default props */
    var subscriptionId = $this.attr('line-item-sub-id');
    var subscriptionIntervalUnitType = $this.attr('line-item-sub-unit');
    props.shipping_interval_frequency = window.bva.subscriptions.default_interval || 2; // theme settings
    props.shipping_interval_unit_type = subscriptionIntervalUnitType;
    props.subscription_id = subscriptionId;

    var skipGlobalUpdate = true;
    (0, _AddToCart.cartRemove)(itemKey, skipGlobalUpdate).then(function (cart) {
      return (0, _AddToCart.cartAdd)(subscriptionVariantId, qty, props);
    }).then(_Cart.updateCartUI).catch(cbError);
  } else {
    /* Replace subscription variant with base variant, remove subscription props */
    delete props.subscription_id;
    delete props.shipping_interval_frequency;
    delete props.shipping_interval_unit_type;

    var _skipGlobalUpdate = true;
    (0, _AddToCart.cartRemove)(itemKey, _skipGlobalUpdate).then(function (cart) {
      return (0, _AddToCart.cartAdd)(baseVariantId, qty, props);
    }).then(_Cart.updateCartUI).catch(cbError);
  }
  // }, 500);
};

var updateLineItemPrice = function updateLineItemPrice(event) {
  var $this = $(event.currentTarget);
  // ensure they aren't going in the negative
  if ($this.val() < 0) {
    $this.val(0);
  }
  var $lineItem = $this.closest(dom.lineItem);
  var qty = $this.val() >= 0 ? $this.val() : 0;
  var rawBasePrice = $lineItem.attr('line-item-base-price');
  var basePrice = parseInt(rawBasePrice, 10);
  var newPrice = qty * basePrice * 100;
  var $priceContainer = $lineItem.find('[data-price]');
  $priceContainer.html((0, _Helpers.formatMoney)(newPrice, CART_MONEY_FORMAT));
};

var updateSubscriptionMeta = function updateSubscriptionMeta(event) {
  if (event.type === 'keypress' && event.keyCode !== 13) return;else if (event.type === 'keypress' && event.keyCode === 13) event.currentTarget.checked = !event.currentTarget.checked;
  // Update price and seasonal note
  var $this = $(event.currentTarget);
  var $lineItem = $this.closest(dom.lineItem);
  var isChecked = $this.is(':checked');
  var qty = $lineItem.find('[line-item-qty]').val();
  var isSeasonal = JSON.parse($this.attr('data-seasonal'));
  // Update price
  var singleItemPrice = isChecked ? $lineItem.attr('data-subscription-price') : $lineItem.attr('data-base-price');
  var lineItemPrice = parseInt(qty, 10) * parseInt(singleItemPrice, 10) * 100;
  $lineItem.attr('line-item-base-price', singleItemPrice);
  var $price = $lineItem.find('[data-line-item-price] [data-price]');
  $price.html((0, _Helpers.formatMoney)(lineItemPrice, CART_MONEY_FORMAT));

  // Toggle seasonal info
  $lineItem.find('[data-item-note]').addClass('u-hidden');
  if (isSeasonal && isChecked) {
    $lineItem.find('[data-item-note]').removeClass('u-hidden');
  }
};

var bindUIActions = function bindUIActions() {
  $(document).on('click', dom.itemRemove, removeLineItemFromCart);

  $(document).on('click', dom.itemQtyAdjust, function (event) {
    var $this = $(event.currentTarget);
    var $qtyInput = $this.siblings(dom.itemQty);
    var updateBy = parseInt($this.attr('line-item-qty-adjust'));
    var currentQty = parseInt($qtyInput.val());
    var itemMax = $qtyInput.attr('max') ? parseInt($qtyInput.attr('max'), 10) : currentQty + updateBy;
    var qty = currentQty + updateBy;
    if (qty <= itemMax) {
      $qtyInput.val(qty).trigger('change');
    }
  });

  // want to send as few AJAX requests as possible
  $(document).on('change', dom.itemQty, debounceQtyUpdate);
  $(document).on('change', dom.itemQty, updateLineItemPrice);

  // $(document).on('change', dom.subscriptionCheckbox, debounceSubscriptionToggle);
  $(document).on('change keypress', dom.subscriptionCheckbox, subscriptionToggle);
  $(document).on('change keypress', dom.subscriptionCheckbox, updateSubscriptionMeta);

  $(document).on('change', dom.subscriptionIntervalSelect, function (event) {
    var $this = $(event.currentTarget);
    var freq = $this.val();
    var $lineItem = $this.closest(dom.lineItem);
    var $matchingIntervalInput = $lineItem.find(dom.subscriptionIntervalInput).filter('[data-dropdown-value="' + freq + '"]');
    $matchingIntervalInput.trigger('click');
  });

  $(document).on('click', dom.subscriptionIntervalInput, function (event) {
    var $this = $(event.currentTarget);
    var freq = $this.find('[subscription-freq]').text();
    var $lineItem = $this.closest(dom.lineItem);
    var $subscriptionCheckbox = $lineItem.find(dom.subscriptionCheckbox);
    var lineNumber = parseInt($subscriptionCheckbox.attr('line-number'));
    var qty = $lineItem.find('[line-item-qty]').val();
    var lineIndex = lineNumber - 1;
    var item = window.bva.cart.items[lineIndex];
    var props = Object.assign({}, item.properties);
    props.shipping_interval_frequency = freq;

    var itemKey = $lineItem.attr('data-item-key');
    (0, _AddToCart.cartChange)(itemKey, qty, props).catch(cbError);

    // Update mobile select
    $(dom.subscriptionIntervalSelect).val(freq);
    $(dom.subscriptionIntervalSelect).find('option').removeProp('selected').filter('[value="' + freq + '"]').prop('selected', true);
  });

  $(document).on('click', dom.noteToggle, function (event) {
    event.stopPropagation();
    var $this = $(event.currentTarget);
    var $lineItem = $this.closest(dom.lineItem);
    var $note = $lineItem.find(dom.note);
    var isActive = $note.hasClass('is-active');
    $(dom.note).removeClass('is-active');
    if (!isActive) {
      $note.addClass('is-active');
    }
  });

  $(document).on('click', dom.note, function (event) {
    event.stopPropagation();
  });

  $(document).on('click', 'body', function (event) {
    var $activeLineItemNotes = $(dom.note + '.is-active');
    if ($activeLineItemNotes.length) {
      $(dom.note).removeClass('is-active');
    }
  });
};

var init = exports.init = function init() {
  bindUIActions();
  console.log('[BVA] Module Loaded: Line Item');
};